import React from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { createServiceCompanyService } from 'DelegationService/DelegationService/Domain/Services/ServiceCompany/CreateServiceCompanyService';
import { getServiceCompanyService } from 'DelegationService/DelegationService/Domain/Services/ServiceCompany/GetServiceCompanyService';
import { patchServiceCompanyService } from 'DelegationService/DelegationService/Domain/Services/ServiceCompany/PatchServiceCompanyService';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { useTranslation } from 'react-i18next';
import { PRIVATE_USER_LIST_DELEGATION_SERVICE, PRIVATE_USER_LIST_SERVICE_COMPANY } from '../../../Constants/PathsConstants';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PropTypes from "prop-types";
import { toast } from 'react-toastify';
import { useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';

FormServiceCompanyView.propTypes = {
    id: PropTypes.string,
};

function FormServiceCompanyView() {
    const { t } = useTranslation();

    const { id } = useParams();

    const [serviceName, setServiceName] = React.useState("");
    const [serviceCIF, setServiceCIF] = React.useState("");
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const navigate = useNavigate();
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    console.log(hasAdminPermission);
    React.useEffect(() => {

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);

        setHasAdminPermission(admin);

        if (!admin) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);


    React.useEffect(() => {
        if (!id || id === 'new') {
            setServiceName("");
            setServiceCIF("");
            return;
        }
        setSendingApiRequest(true);
        getServiceCompanyService(id)
            .then((response) => {
                if (response && response.name) {
                    setServiceName(response.name);
                } else {
                    setServiceName("");
                }
                if (response && response.CIF) {
                    setServiceCIF(response.CIF);
                } else {
                    setServiceCIF("");
                }
            })
            .catch((error) => {
                toast.error(t("serviceCompany.restore.error"));
                console.error("Error fetching service company service", error);
                setServiceName("");
                setServiceCIF("");
            })
            .finally(() => {
                setSendingApiRequest(false);
            });
    }, [id]);

    const handleServiceCompanyNameChange = (event) => setServiceName(event.target.value);
    const handleServiceCompanyCIFChange = (event) => setServiceCIF(event.target.value);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (sendingApiRequest) return;
        setSendingApiRequest(true);

        try {
            let apiResponse = null;

            if (id === "new") {
                apiResponse = await createServiceCompanyService({
                    name: serviceName,
                    CIF: serviceCIF,
                });
            } else {
                apiResponse = await patchServiceCompanyService(id, {
                    name: serviceName,
                    CIF: serviceCIF,
                });
            }

            if (apiResponse !== null) {
                window.location.href = process.env.PUBLIC_URL + PRIVATE_USER_LIST_SERVICE_COMPANY;
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingApiRequest(false);
        }
    };

    return (
        <>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    minHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 3,
                    px: 2,
                }}
            >
                <Typography variant='h4' textAlign="center">
                    {id === "new" ? t('serviceCompany.form.create') : t('serviceCompany.form.update')}
                </Typography>
                <TextField
                    required
                    label={t('serviceCompany.form.serviceCompanyServiceName')}
                    variant='outlined'
                    value={serviceName}
                    onChange={handleServiceCompanyNameChange}
                    sx={{ width: "100%", maxWidth: 400 }}
                />
                <TextField
                    required
                    label={t('serviceCompany.form.serviceCompanyServiceCIF')}
                    variant='outlined'
                    value={serviceCIF}
                    onChange={handleServiceCompanyCIFChange}
                    sx={{ width: "100%", maxWidth: 400 }}
                />
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <Button
                        variant='contained'
                        color='error'
                        component={RouterLink}
                        to={PRIVATE_USER_LIST_SERVICE_COMPANY}
                        startIcon={<CancelIcon />}
                        sx={{
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                        }}
                    >
                        {t('serviceCompany.form.cancel')}
                    </Button>

                    <Button
                        variant="contained"
                        type="submit"
                        startIcon={<SaveIcon />}
                        sx={{
                            backgroundColor: "#0492D4",
                            color: "white",
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                            "&:hover": {
                                backgroundColor: "#037bb5",
                            },
                        }}
                    >
                        {id === "new" ? t('serviceCompany.form.create') : t('serviceCompany.form.update')}
                    </Button>
                </Box>
            </Box>

            <DialogLoader open={sendingApiRequest} />
        </>
    );
}

export default FormServiceCompanyView;